module.exports = __webpack_public_path__ + "static/home-video-full-969f1f7c85b53b9076d666859232af40.mp4";